"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _mobxReact = require("mobx-react");

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _clientErrorLogger = _interopRequireDefault(require("../util/clientErrorLogger"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _ActionRoot = require("./ActionRoot");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Component, storeToPropMapping) {
  var _class, _class2;

  var Propulator = (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    _inherits(Propulator, _React$Component);

    var _super = _createSuper(Propulator);

    function Propulator() {
      _classCallCheck(this, Propulator);

      return _super.apply(this, arguments);
    }

    _createClass(Propulator, [{
      key: "render",
      value: // All the keys of storeToPropMapping should be context stores
      function render() {
        var _this = this;

        var mappedProps = {};
        /**
         *  storeToPropMapping: {
         *      <storeName>: {
         *          <modelName1>: <modelAlias1>,
         *          <modelName2>: <modelAlias2>
         *      }
         *  }
         */

        (0, _forEach.default)(storeToPropMapping, function (modelMapping, storeName) {
          var pascalizedStoreName = (0, _upperFirst.default)((0, _camelCase.default)(storeName));
          (0, _forEach.default)(modelMapping, function (modelAlias, modelName) {
            var sourceName = (0, _isArray.default)(modelMapping) ? modelAlias : modelName;

            if ((0, _isUndefined.default)(_this.context[pascalizedStoreName]) || (0, _isUndefined.default)(_this.context[pascalizedStoreName][sourceName])) {
              _clientErrorLogger.default.notify("Propulator could not find prop", "warning", {
                storeName: pascalizedStoreName,
                modelName: sourceName
              }, true);
            } else {
              mappedProps[modelAlias] = _this.context[pascalizedStoreName][sourceName];
            }
          });
        });
        return /*#__PURE__*/_react.default.createElement(Component, _extends({}, mappedProps, this.props, {
          dispatcher: this.context.dispatcher
        }));
      }
    }]);

    return Propulator;
  }(_react.default.Component), _defineProperty(_class2, "contextType", _ActionRoot.ActionRootContext), _class2)) || _class;

  return Propulator;
};

exports.default = _default;